/* Theme Enhancements JS — smooth, progressive enhancements.
   Non-destructive: only adds behaviors, never removes existing ones.
   step3-perf (20.10.2026): fara 2 ascultatori per imagine (un singur ascultator capturat), reveal cu citiri
   grupate inainte de scrieri (nu mai forteaza reflow la fiecare element). Comportament vizual neschimbat. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Lazy image fade-in
  // Imaginile deja incarcate primesc direct te-loaded; celelalte te-fade (opacity 0) pana la evenimentul load.
  // `load`/`error` nu fac bubble, deci un singur ascultator in faza de captura acopera toate imaginile (si cele aduse ulterior prin AJAX).
  function fadeImages(root) {
    var imgs = (root || document).querySelectorAll('img[loading="lazy"]:not(.te-fade):not(.te-loaded)');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) img.classList.add('te-loaded');
      else img.classList.add('te-fade');
    }
  }
  function onImgDone(ev) {
    var t = ev.target;
    if (t && t.tagName === 'IMG' && !t.classList.contains('te-loaded')) t.classList.add('te-loaded');
  }
  document.addEventListener('load', onImgDone, true);
  document.addEventListener('error', onImgDone, true);

  // 2) Reveal-on-scroll for sections that don't already use the theme's built-in reveal
  function revealOnScroll() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var candidates = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-header):not(.shopify-section-footer) > *:not(.te-reveal)'
    );
    var limit = window.innerHeight * 0.9;
    var targets = [], tops = [], i;
    // faza 1: doar citiri (un singur layout)
    for (i = 0; i < candidates.length; i++) {
      if (candidates[i].classList.contains('scroll-trigger')) continue; // theme already animates it
      targets.push(candidates[i]);
      tops.push(candidates[i].getBoundingClientRect().top);
    }
    // faza 2: doar scrieri
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    for (i = 0; i < targets.length; i++) {
      if (tops[i] < limit) continue; // already in view
      targets[i].classList.add('te-reveal');
      io.observe(targets[i]);
    }
  }

  // 3) Back-to-top button
  function backToTop() {
    if (document.querySelector('.te-to-top')) return;
    var btn = document.createElement('button');
    btn.className = 'te-to-top';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.type = 'button';
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 600) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // 4) Header shadow on scroll (stacks with theme sticky behavior)
  function headerOnScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 8) header.classList.add('te-scrolled');
      else header.classList.remove('te-scrolled');
    }
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  // 5) Smooth anchor jumps
  function smoothAnchors() {
    if (reduceMotion) return;
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#' || id.length < 2) return;
      var tgt = document.querySelector(id);
      if (!tgt) return;
      ev.preventDefault();
      tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // 6) Re-run after Shopify section reloads (theme editor)
  function bindShopifyEvents() {
    if (!window.Shopify) return;
    document.addEventListener('shopify:section:load', function () {
      fadeImages();
      revealOnScroll();
    });
  }

  function init() {
    fadeImages();
    revealOnScroll();
    backToTop();
    headerOnScroll();
    smoothAnchors();
    bindShopifyEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
